import { CwtProp, CwtSchema } from "@cawita/core-front/api";

@CwtSchema()
export class PaidBy {
    @CwtProp() amount: number;
    @CwtProp() bankCheck: number;
    @CwtProp() bankCard: number;
    @CwtProp() cash: number;
}